var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { styled } from '@mui/material';
import { TableCell } from '@mui/material';
import { isEmpty } from '../../../utils';
var TableCellRoot = styled(TableCell)(function (_a) {
    var type = _a.type, checked = _a.checked, theme = _a.theme;
    return __assign(__assign({ padding: '16px', fontSize: 14, borderBottom: '1px solid #f4f4f4' }, (checked && {
        background: theme.palette.primary.light,
    })), (type === 'actions' && {
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
    }));
});
var CellEmpty = function () {
    return React.createElement("span", null, "-");
};
var TbodyCell = function (_a) {
    var type = _a.type, id = _a.id, width = _a.width, row = _a.row, checked = _a.checked, render = _a.render;
    var cell = row[id];
    var isEmptyValue = isEmpty(cell);
    var Cell = function () {
        // 处理自定义render返回
        if (render) {
            return render({ cell: cell, row: row });
        }
        // 处理空字段
        if (isEmptyValue) {
            return React.createElement(CellEmpty, null);
        }
        return cell;
    };
    var rootProps = {
        type: type,
        width: width,
        checked: checked
    };
    return (React.createElement(TableCellRoot, __assign({}, rootProps),
        React.createElement(Cell, null)));
};
export default TbodyCell;
